import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import SkeletonEditField from "@/components/SkeletonEditField.vue";
let TemplateChoiceTypeListItemSkeleton = class TemplateChoiceTypeListItemSkeleton extends Vue {
};
TemplateChoiceTypeListItemSkeleton = __decorate([
    Component({
        components: {
            SkeletonEditField
        },
    })
], TemplateChoiceTypeListItemSkeleton);
export default TemplateChoiceTypeListItemSkeleton;
